import { Divider, Modal, Skeleton } from 'antd';

const ModalWrapper = ({ open, title, content, footer, loading, ...rest }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Modal footer={footer} open={open} title={<h3 className="h3 color-4f5459">{title}</h3>} {...rest}>
    <Divider className="modal_divider" />
    {!!loading && <Skeleton />}
    {!loading && <div className="custom_modal_content">{content}</div>}
    <Divider className="modal_divider" />
  </Modal>
);
export default ModalWrapper;
